import { Helmet } from 'react-helmet-async';

const SITE_URL = (process.env.REACT_APP_SITE_URL || '').replace(/\/$/, '');
const SITE_NAME = 'Pomocnik Żeglarza';

export default function SeoHead({
  title,
  description,
  path = '/',
  noindex = false,
  jsonLd,
}) {
  const url = SITE_URL ? `${SITE_URL}${path}` : null;
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {url && <link rel="canonical" href={url} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
